import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Grid from "@/config/Grid/Grid";
import Button from "@/components/Button/Button";
import { billsPath, orderPaths } from "@/routes/paths";
import styles from "./Order.module.scss";

function OrderFailedPage() {
  const { restaurantId = "", tableId = "" } = useParams<{
    restaurantId: string;
    tableId: string;
  }>();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const paths = orderPaths(restaurantId, tableId);

  /**
   * Two different failures wear this screen. If the order went through and only
   * the payment did not, the food is coming and the guest owes for it, so
   * telling them "nothing was charged, try again" would get it cooked twice.
   */
  const { state } = useLocation();
  const orderPlaced = Boolean(
    (state as { orderPlaced?: boolean } | null)?.orderPlaced,
  );

  return (
    <Grid>
      <div className={`start-1 col-4 ${styles.orderWrapper}`}>
        <div className={styles.orderTerminalContent}>
          <i
            className={`las la-exclamation-circle ${styles.orderTerminalIcon}`}
          />
          <p className={`headline-small ${styles.orderTerminalTitle}`}>
            {t("order.failed.title")}
          </p>
          <p className={`body-medium ${styles.orderTerminalDescription}`}>
            {orderPlaced
              ? t("order.failed.orderPlaced")
              : t("order.failed.description")}
          </p>

          <div className={styles.orderTerminalActions}>
            {orderPlaced ? (
              <Button
                onClick={() =>
                  navigate(billsPath(restaurantId, tableId), { replace: true })
                }
                label={t("order.button.backToBill")}
                variant="contained"
                color="primary"
                maxWidth
                mobile={true}
              />
            ) : (
              <>
                <Button
                  onClick={() => navigate(paths.payment)}
                  label={t("order.button.tryAgain")}
                  variant="contained"
                  color="primary"
                  maxWidth
                  mobile={true}
                />
                <Button
                  onClick={() => navigate(paths.cart)}
                  label={t("order.button.backToCart")}
                  variant="outlined"
                  color="primary"
                  maxWidth
                  mobile={true}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </Grid>
  );
}

export default OrderFailedPage;
